import { useEffect, useState} from 'react';
import {init} from './Web3Client';
import axios from "axios";
import Web3 from 'web3';
import { CryptoFirst_ABI, CryptoFirst_ADDRESS } from '../../contracts'

function WebSmartContractEthers() {

    const [account, setAccount] = useState();
    const [contractList, setContractList] = useState();
    const [contacts, setContacts] = useState([]);
    const [balance, setBalance] = useState();

    // function getToken() {
    //
    //     axios.post({
    //         url: 'http://gate-atom.dltc.spbu.ru:1500',
    //         data: {
    //             method: "eth_call",
    //             params: [],
    //             id: 1,
    //             jsonrpc: '2.0'
    //         },
    //         beforeSend: function(xhr) {
    //             xhr.setRequestHeader("Content-Type", "application/json")
    //         }, success: function(data){
    //             console.log(data)
    //         }
    //     })
    // }

    useEffect(() => {
        async function load() {
            const web3 = new Web3('http://mc99-atom.dltc.spbu.ru:1500');
            // const web3 = new Web3('http://gate-atom.dltc.spbu.ru:1500')
            // const accounts = await web3.eth.getAccounts();
            // setAccount(accounts[0]);
            // const balance = await web3.eth.getBalance(accounts[0])
            // setBalance(balance)
            // const contracts = new web3.eth.Contract(CryptoFirst_ABI, CryptoFirst_ADDRESS)
            // setContractList(contracts)
            // const utils = await web3.utils.sha3('contractOwner(int256)')
            // const owner = await contracts.methods.contractOwner.call((err, result) => {
            //     console.log(result)
            // })
            // console.log('owner', owner)

            const sendContract = await web3.eth.sendTransaction({
                from: "0x24e965d799d60bf9ba517410ddadd926bdd2deae",
                to: '0x22aac56451f9c451f8626ea62c75bccf1cdb7095',
                data: '0x0fb7b3110000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000000600000000000000000000000000000000000000000000000000000000000000030000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000d0000000000000000000000000000000000000000000000000000000064edfad30000000000000000000000000000000000000000000000000000000064edfad30000000000000000000000000000000000000000000000000000000064ed0ad0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000010000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000010000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000002a00000000000000000000000000000000000000000000000000000000000000064000000000000000000000000000000000000000000000000000000000000006400000000000000000000000000000000000000000000000000000000000186a000000000000000000000000000000000000000000000000000000000000186a00000000000000000000000000000000000000000000000000000000000000320000000000000000000000000000000000000000000000000000000000000004b4e756d62317c76696b6275727c6f7267317c636f6e737c6e6f746966797c706f7274317c706f7274327c6f7267317c76657373656c317c646573637c4b47537c4b47537c72656d61726b7300000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000047369676e00000000000000000000000000000000000000000000000000000000'
            })
            // const num = await web3.eth.sendTransaction({
            //     from: "0x962c52864df245890dbdbb9fcf798c8ba39dfd08",
            //     to: '0x22aac56451f9c451f8626ea62c75bccf1cdb7095',
            //     data: '0E8425257347A6B5F7621F3C07CD219E770A30D6E8E85FA402BC62A23AE55CC6'
            // })
            console.log(sendContract)
            // const counter = await contracts.methods.get().call()
            // for (let i = 1; i <= counter; i++) {
            //     const contact = await contracts.methods.contacts(i).call();
            //     setContacts((contacts) => [...contacts, contact]);
            // }
        }
        load();
    }, [])

    // useEffect(() => {
    //     init()
    // }, []);

    console.log(contractList)
    console.log(balance)

    return (
        <div>
            Your account is: {account}
            <h1>Contacts</h1>
        </div>
    );
}

export default WebSmartContractEthers;
